const usStatesMap = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const normalizedStatesMap = Object.entries(usStatesMap).reduce(
  (acc, [code, name]) => {
    acc[code.toLowerCase()] = name; // "ca" → "California"
    acc[name.toLowerCase()] = name; // "california" → "California"
    return acc;
  },
  {}
);

export const getStateFromJobLocation = (jobLocation = "") => {
  const location = jobLocation.toLowerCase();
  const loc = location.split(",").map((item) => item.trim());

  if (location.includes("remote")) {
    return "United States of America";
  }
  for (const key in normalizedStatesMap) {
    if (loc.includes(key)) {
      return normalizedStatesMap[key];
    }
  }

  // Default fallback
  return "United States of America";
};

export const getDomainFromUrl = (url = "") => {
  try {
    return new URL(url).hostname.replace("www.", "");
  } catch {
    return "";
  }
};

export const isEmptyContact = (contact) =>
  !contact.firstName &&
  !contact.lastName &&
  (!contact.email || contact.email.length === 0) &&
  !contact.designation;
